module.exports = __webpack_public_path__ + "img/accept.ece76231.svg";